module.exports = __webpack_public_path__ + "img/SkyvsVTAF.f25e09a2.png";